import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PeriodoPage } from '../pages/periodo.page';

const PeriodoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/periodo' element={<PeriodoPage />} />
    </Routes>
  );
};

export { PeriodoRoutes };
